import _ from 'lodash';
// import objectAssign from 'object-assign';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../../actions/reportActions';
// import ReactPivot from 'react-pivot';
import * as d3 from 'd3';
import pivot from 'quick-pivot';
import './pivot.scss';


class PivotReport extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    // this.renderRow = this.renderRow.bind(this);
    // this.renderCell = this.renderCell.bind(this);
    // this.renderHeaderCell = this.renderHeaderCell.bind(this);
    this.prepareDataD3 = this.prepareDataD3.bind(this);
    this.nestStructure = this.nestStructure.bind(this);
    this.renderHeaders = this.renderHeaders.bind(this);
    this.renderRow = this.renderRow.bind(this);
    this.renderRowHeaders = this.renderRowHeaders.bind(this);
    this.renderCells = this.renderCells.bind(this);
    this.flattenRow = this.flattenRow.bind(this);
    // this.extractHeaders = this.extractHeaders.bind(this);
    // this.extractRowHeaders = this.extractRowHeaders.bind(this);
    // this.extractColHeaders = this.extractColHeaders.bind(this);
		this.state = {
			pivotedData: {table: []},
			table: [],
			fields: [
				{value: 'team_id', text: 'Gruppe ID'},
				{value: 'team_name', text: 'Gruppenavn'},
				{value: 'name', text: 'Fullt navn'},
				{value: 'first_name', text: 'Fornavn'},
				{value: 'last_name', text: 'Etternavn'},
				{value: 'club_name', text: 'Klubbnavn'},
				{value: 'team_category', text: 'Gruppekategori'},
				{value: 'category_names', text: 'Deltagerkategorier'},
			],
			aggrTypes: [
				{value: 'count', text: 'Antall'},
				{value: 'sum', text: 'Sum'},
			],
			// cols: [
			// 	{value: 'club_name', text: 'Klubbnavn'},
			// 	{value: 'team_name', text: 'Gruppenavn'},
			// ],
			// rows: [
			// 	{value: 'team_category', text: 'Gruppekategori'},
			// ],
			cols: [
				{value: 'club_name', text: 'Klubbnavn'},
				{value: 'team_name', text: 'Gruppenavn'},
			],
			rows: [
				{value: 'team_category', text: 'Gruppekategori'},
			],
			aggrCategory: 'team_name',
			aggrType: 'count',
		};
  }

  componentWillMount() {
    this.props.actions.loadReportDetails(this.props.eventId, 1);
  }

	componentWillReceiveProps(nextProps) {
		if (nextProps.detailsUpdated != this.props.detailsUpdated) {
			this.setState({
				table: this.prepareDataD3(nextProps.pivotDetails),
			});
		}
	}

	nestStructure() {
		let nestedData = d3.nest();
		let fields = _.concat(this.state.cols, this.state.rows);
		fields.forEach((field) =>{
			nestedData.key(function(d) {
				return d[field.value];
			});
		});
		nestedData.rollup(function(leaves) { return leaves.length; });
		return nestedData;
	}

	prepareDataD3(pivotDetails) {
		let structure = this.nestStructure();
		let result = structure.entries(pivotDetails);
		return result;
	}

	renderHeaderCell(cell, rowSpan=1, colSpan=1) {
		return (
			<th rowSpan={rowSpan} colSpan={colSpan}>
				{cell}
			</th>
		);
	}

	renderHeaders(thead, row, depth=1) {
		let colHeaderSize = _.size(this.state.cols);
		let tr = thead.append('tr');
		tr.selectAll('th')
			.data(row)
			.enter()
			.append('th')
			.attr("colspan", (d) => {
				if (depth < (colHeaderSize)) {
					return _.size(d.values);
				} else {
					return 1;
				}
			})
			.text(function(cell) {
				return cell.key;
			});
		if (depth < colHeaderSize) {
			let nextRow = _.flatMap(row, 'values');
			this.renderHeaders(thead, nextRow, depth=(depth+1));
		}
		return tr;
	}

	renderRow(tbody, rows, depth=1) {
		// let colHeaderSize = _.size(this.state.cols);
		// let tableRows = _.flatMapDeep(rows, 'values')
		// tbody.selectAll('tr')
		// 	.data(tableRows).enter()
		// 	.append('tr')
		// 	.selectAll('td')
		// 	.data((row, index) => {
		// 		
		// 	})
		// 	.text(function() {
		// 		return 'test'
		// 	})
		// rows.forEach((row) => {
		// 	let tr = tbody.append('tr');
		//
		// 	// if (depth < colHeaderSize) {
		// 	// 	this.renderRow(tbody, row.values, depth=(depth+1));
		// 	// } else {
		// 	// 	let tr = tbody.append('tr');
		// 	// 	this.renderRowHeaders(tr, row.values);
		// 	// }
		// });
	}

	renderCells(rowElement, row) {
		rowElement.append('th')
			.text(function() {
				return row.key;
			});
		rowElement.append('td')
			.text(function() {
				return row.value;
			});
		// let rowHeaderSize = _.size(this.state.rows);
		// cells.forEach((cell) => {
		// 	if (depth < rowHeaderSize) {
		// 		rowElement.append('th')
		// 			.text(function() {
		// 				return cell.key;
		// 			});
		// 		this.renderCells(rowElement, cell.values, depth=depth+1);
		// 	} else {
		//
		// 	}
		// });
	}

	flattenRow(row) {
		if (row.values) {
			return [row.key, this.flattenRow(row.values)];
		} else {
			return [row.key, row.value];
		}
	}

	renderRowHeaders(tr, row, depth=1) {
		let rowHeaderSize = _.size(this.state.rows);
		row.forEach((th) => {
			tr.append('th')
			.attr("rowspan", () => {
				return _.size(row);
			})
			.text(function() {
				return th.key;
			});
			if (depth < rowHeaderSize) {
				this.renderRowHeaders(tr, row.values, depth=depth+1);
			}
		})
	}

  render() {
		let table = d3.select('#pivot-table');
		table.selectAll("*").remove();
		let thead = table.append('thead');
		let	tbody = table.append('tbody');
		// let fields = _.concat(this.state.cols, this.state.rows);
		let tr = this.renderHeaders(thead, this.state.table);
		tr.insert('th', ':first-child')
			.attr('rowspan', () => {return _.size(this.state.cols);})
			.attr('colspan', () => {return _.size(this.state.rows);});
		this.renderRow(tbody, this.state.table);

		// this.state.table.forEach((item, index) => {
		//
		// });
		// thead.append('tr')
		// 	.selectAll('th')
		// 	.data(columns).enter()
		// 	.append('th')
		// 		.text(function (column) { return column; });
    return (
      <div className="pivot-report pivot-report-container container-fluid">
				<div className="row">
					<div className="col-sm-4 col-lg-3">
						<div className="panel panel-default">
							<div className="panel-heading">
								<h5>Pivot</h5>
							</div>
							<div className="panel-body pivot-sidebar">

								<h5>Tilgjengelige felter:</h5>
								<div className="well well-sm options-well">
									{this.state.fields.map((field, index) => {
										return (
											<span key={index}>
												<span className="label label-primary label-lg">
													{field.text}
												</span>
												{' '}
											</span>
										);
									})}
								</div>

								<h5>Rader:</h5>
								<div className="well well-sm options-well">
									{this.state.rows.map((field, index) => {
										return (
											<span key={index}>
												<span className="label label-primary label-lg">
													{field.text}
												</span>
												{' '}
											</span>
										);
									})}
								</div>

								<h5>Kolonner:</h5>
								<div className="well well-sm options-well">
									{this.state.cols.map((field, index) => {
										return (
											<span key={index}>
												<span className="label label-primary label-lg">
													{field.text}
												</span>
												{' '}
											</span>
										);
									})}
								</div>
							</div>
						</div>
					</div>
					<div className="col-sm-8 col-lg-9">
						<div className="panel panel-default">
							<div className="panel-heading">
								<h5>Tabell</h5>
							</div>
							<div className="panel-body pivot-table-container">
								<table className="table table-bordered table-responsive table-hover"
									id="pivot-table" />
							</div>
						</div>
					</div>
				</div>
      </div>
    );
  }
}

PivotReport.propTypes = {
  actions: PropTypes.object.isRequired,
  pivotDetails: PropTypes.array.isRequired,
  detailsUpdated: PropTypes.number.isRequired,
  eventId: PropTypes.string.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    eventId: ownProps.params.eventId,
    loading: state.reports.loading,
    pivotDetails: state.reports.pivotDetails,
    detailsUpdated: state.reports.detailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PivotReport);



/** WEBPACK FOOTER **
 ** ./src/containers/events/reports/PivotReport.js
 **/